import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import SuccessModal from "../../SuccessModal";
import { mapWarehouseWithStore } from "../../../services/warehouse/WarehouseWithStore";
import { addWarehouseWithUser } from "../../../services/warehouse/WarehouseWithUser";

const WarehouseUserAddModal = ({
  warehouseUserAddModalVisible,
  setWarehouseUserAddModalVisible,
  sendDataToWarehouseConfig,
  brandId,
  userList,
  warehouseId,
}) => {
  const OrderStatus = userList;

  const ordersData_ROLE_WAREHOUSE = OrderStatus.filter(
    item => item.mapped === false && item.role === 'ROLE_WAREHOUSE',
  );
  const ordersData_ROLE_WAREHOUSE_USER = OrderStatus.filter(
    item => item.mapped === false && item.role === 'ROLE_WAREHOUSE_USER',
  );

  const ordersData = [
    ...ordersData_ROLE_WAREHOUSE,
    ...ordersData_ROLE_WAREHOUSE_USER,
  ];

  const [selectedStatus, setSelectedStatus] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState('');
    const [submitButtonPress, setSubmitButtonPress] = useState(false);
  

  const handleStatusToggle = status => {
    const updatedStatus = [status];
    setSelectedStatus(updatedStatus);
  };
  const handleDataSubmit = () => {
    setSubmitButtonPress(true);

    const updatedData = {
      userId: selectedStatus[0].id,
      warehouse: {
        id: warehouseId,
      },
      status: 'true',
    };
    addWarehouseWithUser(brandId, updatedData)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            const message = Res.message;
            const status = Res.status;
            setWarehouseUserAddModalVisible(false);
            sendDataToWarehouseConfig({
              success: true,
            });
            if (status === true) {
              setModalVisible(true);
              setModalStatus('success');
              setModalText(message);
              setSubmitButtonPress(false);

            } else {
              setModalVisible(true);
              setModalStatus('not Success');
              setModalText(message);
              setSubmitButtonPress(false);

            }
            setSelectedStatus([]);
          }
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };
  const handleModalClose = () => {
    setWarehouseUserAddModalVisible(false);
    setSelectedStatus([]);
              setSubmitButtonPress(false);

  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={warehouseUserAddModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!warehouseUserAddModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-1 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <img
                style={{
                  height: 45,
                  width: 45,
                  // alignSelf: 'center',
                }}
                src={"images/plus.png"}
              />

              <p className=" text-4xl text-primary-50 font-semibold">
                ADD USER
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>
            <div
              className="h-20rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
              <div className="mx-4">
              {ordersData?.length > 0 ? (
                ordersData?.map(item => (
                    <div
                      key={item.id}
                      className="flex flex-1 my-1"
                    >
                      <p className="flex-1 text-xl font-medium">{(item.firstName + ' ' + item.lastName).substring(
                          0,
                          16,
                        )}
                        {(item.firstName + ' ' + item.lastName).length > 16
                          ? '...'
                          : ''}</p>
                          <p className="flex-1 text-xl font-medium">{item.role.replace(/ROLE_/g, ' ').substring(0, 16)}
                          {item.role.replace(/ROLE_/g, ' ').length > 16
                            ? '...'
                            : ''}</p>
                      <div>
                        <Checkbox
                          checked={selectedStatus.includes(item)}
                          size="20" // Increased size
                          color={
                            selectedStatus.includes(item)
                              ? "#00A3FF"
                              : "#C1C9D3"
                          }
                          onClick={() => handleStatusToggle(item)}
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="flex justify-content-center">
                    <p className="text-xl font-medium">
                      No User Data Found
                    </p>
                  </div>
                )}
              </div>
            </div>
            {OrderStatus.length !== 0 && (
            <div className="flex ">
              <Button
                onClick={handleDataSubmit}
                className="mb-3 mx-4 border-round-xl w-full"
                disabled={
                  selectedStatus?.length <= 0 || submitButtonPress
                }
              >
                <p className=" w-full text-2xl font-semibold flex justify-content-center">
                ADD
                </p>
              </Button>
            </div>
            )}
          </div>
        )}
      ></Dialog>
       <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
};

export default WarehouseUserAddModal;
